import { CandyThunkAction } from "../../Engine/Core/Store/CandyReduxTypes";
import { GetContractorResponse } from "../Types/ContractorsTypes";

import { ContractorsActionType } from "./ContractorsAction";

export function importContractors(contractors: GetContractorResponse[]): CandyThunkAction {
    return (dispatch, getState) => {
        getState().contractors?.resultDeferred?.resolve(contractors);
        dispatch({ type: ContractorsActionType.CompleteImport });
    };
}

export function cancelImportContractors(): CandyThunkAction {
    return (dispatch, getState) => {
        getState().contractors?.resultDeferred?.resolve(undefined);
        dispatch({ type: ContractorsActionType.CompleteImport });
    };
}
